import Skeleton from 'react-loading-skeleton'
import styled, { css } from 'styled-components'
import * as ScrollArea from '@radix-ui/react-scroll-area'
import { ResponsiveImage } from '@velasca/ui/responsive-image'

export const ImagesPageProductContainer = styled.div<{
  thumbnailSidebar: boolean
}>`
  position: relative;
  ${({ thumbnailSidebar }) => {
    if (thumbnailSidebar) {
      return css`
        display: grid;
        grid-template-columns: minmax(auto, 11%) auto;
        gap: 0.5rem;
      `
    }

    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
    `
  }}
`

export const ThumbnailSidebarContainer = styled.div<{ $headerHeight: number }>`
  /* Make the sidebar sticky when present as a grid column */
  position: sticky;
  top: ${({ $headerHeight }) => $headerHeight}px;
  align-self: start;

  [data-radix-scroll-area-viewport] {
    max-height: calc(100vh - ${({ $headerHeight }) => $headerHeight}px);
  }
`

export const ThumbnailSidebarViewport = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`

export const StyledScrollAreaScrollbar = styled(ScrollArea.Scrollbar)`
  width: 4px;
  background: #d9d9d9;
`
export const StyledScrollAreaThumb = styled(ScrollArea.Thumb)`
  background: ${({ theme }) => theme.colors.hover};
`

export const ThumbnailForSidebar = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const ContainerGrid = styled.div`
  position: relative;
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  justify-items: stretch;
  gap: 0.5rem;
`

export const GridElement = styled.div<{
  stretch: boolean
  zoom: boolean
  customZoomIconUrl?: string
}>`
  position: relative;
  ${(props) => (props.stretch ? 'grid-column: 1 / span 2;' : '')}

  ${(props) =>
    props.zoom &&
    css`
      cursor: ${props.customZoomIconUrl
        ? `url(${props.customZoomIconUrl}), zoom-in`
        : 'zoom-in'};
    `};
`

export const Image = styled(ResponsiveImage)<{
  imageWidth: number
  imageHeight: number
}>`
  width: 100%;
  aspect-ratio: ${({ imageWidth, imageHeight }) =>
    Math.round((imageWidth / imageHeight) * 100) / 100};

  .safari-lower-than-15 & {
    padding-top: ${({ imageWidth, imageHeight }) =>
      `${((imageHeight / imageWidth) * 100).toFixed(2)}%`};
  }
`

export const ImageSkeleton = styled(Skeleton)<{
  imageWidth: number
  imageHeight: number
}>`
  width: 100%;
  aspect-ratio: ${({ imageWidth, imageHeight }) =>
    Math.round((imageWidth / imageHeight) * 100) / 100};

  .safari-lower-than-15 & {
    padding-top: ${({ imageWidth, imageHeight }) =>
      `${((imageHeight / imageWidth) * 100).toFixed(2)}%`};
  }
`

const ArrowContainer = styled.div`
  user-select: none;
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
`

export const LeftArrowContainer = styled(ArrowContainer)`
  z-index: 999999;
  left: 0;
`

export const RightArrowContainer = styled(ArrowContainer)`
  z-index: 999999;
  right: 0;
`

export const Model = styled.div<{
  isFullScreen: boolean
  width: number
  height: number
}>`
  #sketchfab-tile-player {
    width: 100%;
    height: 100%;
  }

  ${({ isFullScreen, width, height }) =>
    isFullScreen
      ? css`
          position: fixed;
          width: 100vw;
          height: 100vh;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          z-index: 999999;
        `
      : css`
          position: relative;
          width: 100%;
          aspect-ratio: ${Math.round((width / height) * 100) / 100};

          .safari-lower-than-15 & {
            padding-top: ${((height / width) * 100).toFixed(2)}%;
          }
        `}
`

export const VideoContainer = styled.div<{
  mediaWidth: number
  mediaHeight: number
}>`
  aspect-ratio: ${({ mediaWidth, mediaHeight }) =>
    `${mediaWidth}/${mediaHeight}`};
  height: auto;

  .safari-lower-than-15 & {
    padding-top: ${({ mediaWidth, mediaHeight }) =>
      `${((mediaHeight / mediaWidth) * 100).toFixed(2)}%`};
  }
`

export const VideoTile = styled.video`
  display: block;
  width: 100%;
  height: 100%;
`

export const DefectiveMedia = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.brand};
  font-size: 1.6rem;
  font-weight: 300;
`
